export default "__VITE_ASSET__b60cff0d__"